// removed by extract-text-webpack-plugin
module.exports = {"Btn":"qW8_i0pG0Koq4_dHJLCFG"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ComponentsOfAdministrator/AccountAdd/styles.module.css
// module id = 529
// module chunks = 0